/**
 * Created by wuyanbin on 2019/5/28
 */
import { __awaiter } from "tslib";
import { createStore } from '@souche-f2e/muji';
import Api from '@/services';
import { getAllResources } from '@/shared/functions';
import { token } from '@/shared/token';
import { getPowerMenu } from '@/shared/menuData';
export default createStore({
    state: {
        currentUser: null,
        // 资源
        resources: [],
        // 菜单
        menus: [],
        testMenus: [
        // {
        //   link:'/DataStatistics',
        //   title:'报表',
        //   subMenus:[{
        //     link:'/DataStatistics/ReportList',
        //     title:'报表列表',
        //   }],
        // },
        ],
        menuObjectList: [],
        breadObjectList: [],
    },
    reducers: {
        SET_STATE(state, payload) {
            Object.keys(payload)
                .forEach((key) => {
                if (typeof payload[key] !== 'undefined') {
                    state[key] = payload[key];
                }
            });
        },
    },
    effects: {
        // 获取资源权限
        getAuthZ(payload, { state }) {
            return __awaiter(this, void 0, void 0, function* () {
                yield Api.user.getAuthZ({
                    _security_token: token,
                }).then((res) => {
                    this.SET_STATE({
                        resources: getAllResources(res.resources) || [],
                        menus: [...res.menus, ...state.testMenus],
                    });
                });
                const { menu, bread } = getPowerMenu();
                this.SET_STATE({
                    menuObjectList: menu,
                    breadObjectList: bread,
                });
            });
        },
        export(paramsData, { state }) {
            return __awaiter(this, void 0, void 0, function* () {
                const { type, fileName, params } = paramsData;
                // @ts-ignore
                Api[type].globalExport(Object.assign({}, params)).then((res) => {
                    const content = res;
                    const elink = document.createElement('a');
                    elink.download = `${fileName}.xls`; // 设置下载文件名
                    elink.style.display = 'none';
                    const blob = new Blob([content]);
                    elink.href = URL.createObjectURL(blob);
                    document.body.appendChild(elink);
                    elink.click();
                    document.body.removeChild(elink);
                });
            });
        },
    },
});
